import { getTiersImageURL, getImageURL } from '../utils/GeneralUtil';
// Assets, Images
export var assets = {
    cardIcons: {
        DedicatedAcctMgmt: getTiersImageURL("cardIcon-DedicatedAcctManagment-square.svg"),
        EliteSupportLine: getTiersImageURL("cardIcon-EliteSupportLine-square.svg"),
        ManagedAcctRebate: getTiersImageURL("cardIcon-ManagedAcctRebate-square.svg"),
        PaintRewards_Bronze: getTiersImageURL("cardIcon-PaintRewards-Bronze-square.svg"),
        PaintRewards_Gold: getTiersImageURL("cardIcon-PaintRewards-Gold-square.svg"),
        PaintRewards_Member: getTiersImageURL("cardIcon-PaintRewards-Member-square.svg"),
        PaintRewards_Silver: getTiersImageURL("cardIcon-PaintRewards-Silver-square.svg"),
        PersonalOffers: getTiersImageURL("cardIcon-PersonalOffers-square.svg"),
        PreferredPricing: getTiersImageURL("cardIcon-PreferredPricing-square.svg"),
        ProXtraPerks: getTiersImageURL("cardIcon-ProXtraPerks-square.svg"),
        VPP_black: getTiersImageURL("cardIcon-VPP-black-square.svg"),
        BusinessTools: getTiersImageURL("icon-BusinessTools.svg"),
        VIPExperiences: getTiersImageURL("icon-thin-giftCard.svg"),
        ExclusiveSales: getTiersImageURL("icon-ExclusiveSalesEvents.svg"),
        ChallengeIcon: getImageURL('ChallengeIcon.svg'),
    },
    caretRight: getTiersImageURL('caret-white.svg'),
    carousel: {
        brand_next: getTiersImageURL('carousel-brand-next.svg'),
        brand_previous: getTiersImageURL('carousel-brand-previous.svg'),
        state_active: getTiersImageURL('carousel-state-active.svg'),
        state_default: getTiersImageURL('carousel-state-default.svg'),
    },
    chevron_brand_left: getTiersImageURL('chevron-brand-left.svg'),
    chevron_brand_right: getTiersImageURL('chevron-brand-right.svg'),
    icons: {
        amBenefitsCheckmark: getTiersImageURL('amBenefits-checkmark.svg'),
        amBenefitsDuplicate: getTiersImageURL('amBenefits-duplicate.svg'),
        badge_unlocked: getTiersImageURL('icon-badge-unlocked-square.svg'),
        badge_unlocked_white: getTiersImageURL('icon-badge-unlocked-white.svg'),
        chalkboard_arrow_white: getTiersImageURL('icon-chalkboard-arrow-white.svg'),
        close: getTiersImageURL('icon-close.svg'),
        error: getTiersImageURL('icon-error.svg'),
        expiring: getTiersImageURL('icon-expiring.svg'),
        info: getTiersImageURL('icon-info.svg'),
        locked: getTiersImageURL('icon-locked.svg'),
        mobile_app: getTiersImageURL('icon-mobile-app.svg'),
        Perks_Available: getTiersImageURL('icon-Perks-Available.svg'),
        phone: getImageURL('proXtra-phone-icon.svg'),
        pxcc: getTiersImageURL('PXCC-padded-square.svg'),
        refresh: getTiersImageURL('icon-refresh.svg'),
        TierLock: getTiersImageURL('icon-TierLock.svg'),
        unlocked: getTiersImageURL('icon-unlocked.svg'),
        warning: getTiersImageURL('icon-warning.svg'),
    },
    proXtraLogoTextReversed: getTiersImageURL('Pro-Xtra-logo-text-reversed.svg'),
    proXtraLogoText: getTiersImageURL('Pro-Xtra-logo-text.svg'),
    tabsTiers: {
        bg_ELITE: getTiersImageURL('tabsTiers-bg-ELITE.svg'),
        bg_MEMBER: getTiersImageURL('tabsTiers-bg-MEMBER.svg'),
        bg_unlocked: getTiersImageURL('tabsTiers-bg-unlocked.svg'),
        bg_VIP: getTiersImageURL('tabsTiers-bg-VIP.svg'),
        ELITE_locked: getTiersImageURL('tabsTiers-ELITE-locked.svg'),
        ELITE_unlocked: getTiersImageURL('tabsTiers-ELITE-unlocked.svg'),
        MEMBER_unlocked: getTiersImageURL('tabsTiers-MEMBER-unlocked.svg'),
        VIP_locked: getTiersImageURL('tabsTiers-VIP-locked.svg'),
        VIP_unlocked: getTiersImageURL('tabsTiers-VIP-unlocked.svg'),
        x_ELITE: getTiersImageURL('tabsTiers-x-ELITE.svg'),
        x_MEMBER: getTiersImageURL('tabsTiers-x-MEMBER.svg'),
        x_VIP: getTiersImageURL('tabsTiers-x-VIP.svg'),
    },
    tierBadge: {
        ELITE: getImageURL('Tier-Badge-X-Elite.svg'),
        MEMBER: getImageURL('Tier-Badge-X-Member.svg'),
        VIP: getImageURL('Tier-Badge-X-VIP.svg'),
    },
};
